var render = function () {
  var _vm$detail, _vm$detail2, _vm$detail2$orderList;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "company-applyment-module"
  }, [_c('el-affix', {
    class: {
      'applyment-page-header-top': _vm.affixed,
      'applyment-page-header-shrink': _vm.sidebarFold,
      'applyment-page-header-unfold': !_vm.sidebarFold
    },
    attrs: {
      "offset": 80
    },
    on: {
      "change": _vm.handleAffixChange
    }
  }, [_c('el-card', [_c('div', {
    staticClass: "applyment-page-header"
  }, [_c('div', {
    staticClass: "status"
  }, [_vm._v(" " + _vm._s(_vm.refundStatusFormat(_vm.detail.status)) + " ")]), _c('div', {
    staticClass: "page-header-heading-right"
  }, [_c('div', {
    staticClass: "ml10 hg36 opts"
  }, [_vm.isAuth('finance:financial') && ['REFUNDING', 'REFUND_INFO_UPDATED', 'REFUND_PENDING'].includes((_vm$detail = _vm.detail) === null || _vm$detail === void 0 ? void 0 : _vm$detail.status) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.handleConfirmRefund
    }
  }, [_vm._v(" Confirm Refund ")]) : _vm._e()], 1)])])])], 1), _vm.detail ? _c('div', {
    staticClass: "step mt20"
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('refund-info', {
    attrs: {
      "detail": _vm.detail
    }
  })], 1)], 1) : _vm._e(), ((_vm$detail2 = _vm.detail) === null || _vm$detail2 === void 0 ? void 0 : (_vm$detail2$orderList = _vm$detail2.orderList) === null || _vm$detail2$orderList === void 0 ? void 0 : _vm$detail2$orderList.length) > 0 ? _c('div', {
    staticClass: "step mt20"
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('linked-order-list', {
    attrs: {
      "detail": _vm.detail
    }
  })], 1)], 1) : _vm._e(), _c('confirm-refund', {
    ref: "confirmRefundModal",
    attrs: {
      "detail": _vm.detail
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }